import { Datagrid, List, Loading, TextField, TopToolbar, useGetList, useLocaleState, useTranslate } from "react-admin";
import { Link, useParams } from "react-router-dom";
import { Button } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { makeStyles } from "@mui/styles";
import { StartPageRowEdit } from "./startPageRow.edit.component";

const useStyles = makeStyles({
    emptyRow: { display: "flex", marginTop: "32px", justifyContent: "center"},
});

const CustomCreateButton = (props: any) => {
    const translate = useTranslate();
    return (
        <Button
            {...props}
            component={Link}
            to={`/startpages/1/rows/create`}
            startIcon={<AddIcon/>}
        >
            {translate('resources.startpages.create')}
        </Button>
    )
};

const CustomActions = () => {
    return (
        <TopToolbar>
            <CustomCreateButton/>
        </TopToolbar>
    )
}

export const StartPageRowList = () => {
    const { pageId } = useParams();
    const classes = useStyles();

    const list = useGetList("startpages/rows", {
        filter: { pageId },
    });
    const [locale] = useLocaleState();

    if (list.isLoading) {
        return <Loading></Loading>;
    }

    return (
        <>
            <List resource="startpages/rows" filter={{ pageId }} actions={<CustomActions/>}>
                <Datagrid rowClick="edit" expand={<StartPageRowEdit/>}>
                    <TextField source={`title.${locale}` } label="resources.startpages.fields.title"/>
                </Datagrid>
            </List>
            { list?.data?.length === 0 && (
                <div className={classes.emptyRow}>
                    <CustomCreateButton variant="contained" size="small"/>
                </div>
            )}
        </>
    );
};